import * as React from 'react';
import PropTypes from 'prop-types';
import logo from '../../assets/logo.png';

export default class Progress extends React.Component {
  render() {
    const { title, message } = this.props;

    return (
      <div className="min-h-screen bg-white flex items-center justify-center p-4">
        <div className="text-center max-w-md w-full">
          {/* Logo Container */}
          <div className="mb-8">
            <img 
              width="80" 
              height="80" 
              src={logo} 
              alt="Revit CRM" 
              title="Revit CRM"
              className="mx-auto"
            />
          </div>

          {/* Simple Spinner */}
          <div className="mb-6">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-500 mx-auto">
            </div>
          </div>

          {/* Loading Text */}
          <div className="space-y-3">
            <h2 className="text-lg font-medium text-gray-900">
              Revit CRM
            </h2>
            
            <p className="text-sm text-gray-600">
              {message || 'Add-in loading, please wait...'}
            </p>
          </div>
        </div>
      </div>
    );
  }
}

Progress.propTypes = {
  message: PropTypes.string,
  title: PropTypes.string,
};